export default __webpack_public_path__ + "123748d197c369031c10f998503bf45f.svg";